import { __decorate, __metadata } from "tslib";
import { DiningOptionEnum, IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayUnique, IsArray, IsEnum, IsInstance, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { StoreItemsExposeGroup } from '../enum';
import { ReadAbstractItemMetadataDto } from './ReadAbstractItemMetadataDto';
import { ReadStoreItemComboMetadataPosDto } from './ReadStoreItemComboMetadataPosDto';
import { ReadStoreItemMetadataCategoryDto } from './ReadStoreItemMetadataCategoryDto';
export class ReadStoreItemComboMetadataDto extends ReadAbstractItemMetadataDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 0 }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.BATCH_CREATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
        ],
    }),
    IsNumber({}, { always: true }),
    __metadata("design:type", Number)
], ReadStoreItemComboMetadataDto.prototype, "show_order", void 0);
__decorate([
    ApiProperty({ type: () => String, isArray: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    IsNotEmpty({ always: true, each: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemComboMetadataDto.prototype, "categories", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadStoreItemMetadataCategoryDto, isArray: true }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadStoreItemMetadataCategoryDto),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    IsInstance(ReadStoreItemMetadataCategoryDto, { each: true, always: true }),
    __metadata("design:type", Array)
], ReadStoreItemComboMetadataDto.prototype, "categoryProperties", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadStoreItemComboMetadataDto.prototype, "additional_info", void 0);
__decorate([
    ApiProperty({ type: () => ReadStoreItemComboMetadataPosDto }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    Type(() => ReadStoreItemComboMetadataPosDto),
    IsInstance(ReadStoreItemComboMetadataPosDto, { always: true }),
    ValidateNested({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    __metadata("design:type", ReadStoreItemComboMetadataPosDto)
], ReadStoreItemComboMetadataDto.prototype, "pos", void 0);
__decorate([
    ApiPropertyOptional({ enum: DiningOptionEnum, isArray: true, example: [DiningOptionEnum.TAKE_OUT] }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ always: true }),
    IsArray({ always: true }),
    IsEnum(DiningOptionEnum, { each: true, always: true }),
    ArrayUnique({ always: true }),
    __metadata("design:type", Array)
], ReadStoreItemComboMetadataDto.prototype, "diningOptions", void 0);
//# sourceMappingURL=ReadStoreItemComboMetadataDto.js.map